import { FC } from "react";
import {
  TrackingContext,
  TrackingProviderProps,
  getTrackingIdHelper,
} from "./TrackingProviderContext";

// This works with the IdentifierContext to provide scope to the components.
// This can also act as a gatekeeper to only give unique ids within the Provider, but this is not a currently implemented feature.
export const TrackingProvider: FC<TrackingProviderProps> = ({
  children,
  scope,
  optOut = false,
}) => {
  const value = {
    scope,
    getTrackingId: (name: string, component: string) =>
      getTrackingIdHelper(name, component, scope),
    optOut,
  };

  return (
    <TrackingContext.Provider value={value}>
      {children}
    </TrackingContext.Provider>
  );
};
